import { render, staticRenderFns } from "./challenge-notes.vue?vue&type=template&id=dd2aed10&scoped=true"
import script from "./challenge-notes.vue?vue&type=script&setup=true&lang=js"
export * from "./challenge-notes.vue?vue&type=script&setup=true&lang=js"
import style0 from "./challenge-notes.vue?vue&type=style&index=0&id=dd2aed10&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd2aed10",
  null
  
)

export default component.exports